import { useField } from "formik";
import { FC } from "react";

import { Switch } from "~/src/components/common/Switch";

export type Props = {
  name: string;
};

export const FormikSwitchField: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ name }) => {
  const [{ value, onChange }] = useField<boolean>(name);

  return <Switch name={name} isChecked={value} onChange={onChange} />;
};
